import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { posNotificationServiceUrl } from '../../../../urls'

const headers = {
	'Content-Type': 'application/json',
	'X-Requested-With': 'XMLHttpRequest'
}

const posNotificationInstance = axios.create({
	baseURL: posNotificationServiceUrl,
	headers
})

posNotificationInstance.interceptors.request.use(requestInterceptor, error => Promise.reject(error))

posNotificationInstance.interceptors.response.use(response => response, error => {
	return responseInterceptor(error)
})

export default posNotificationInstance
